import React from 'react';
import { StyledTextArea } from './styles';
import { ITextarea } from './types';

const Textarea: React.FunctionComponent<ITextarea> = ({ isError, disabled, children, ...rest }) => {
    return <StyledTextArea isError={isError} disabled={disabled} {...rest}>{children}</StyledTextArea>;
};

export default Textarea;
